module.exports = __webpack_public_path__ + "img/2018成都调研会.bdf38a73.jpg";